import { List, ListItem, ListItemText } from "@mui/material"

export function DlspStatusList({registryStatus}) {

    if (registryStatus && ["inactive", "active"].includes(registryStatus.toLowerCase())) {
        return (
            <List>
                <ListItem sx={{p: 0, display: 'list-item'}}>
                    <ListItemText primary="Desktop QA"    secondary="Keep this task in the Desktop QA list, but save comments, etc." />
                </ListItem>
                <ListItem sx={{p: 0, display: 'list-item'}}>
                    <ListItemText primary="Field"         secondary="Request a field inspection to gather more information. Please use the comments field to say what information is needed and provide a separate list of required photos." />
                </ListItem>
                <ListItem sx={{p: 0, display: 'list-item'}}>
                    <ListItemText primary="Remedial"      secondary="Contact the customer to ask about decommissioning. Optionally also say remedial work is required by Northpower Contracting. Creates a Salesforce Case for the work. Your comments go on to the case." />
                </ListItem>
                <ListItem sx={{p: 0, display: 'list-item'}}>
                    <ListItemText primary="Eliminated"    secondary="Assess this ICP as safe and still required by the customer." />
                </ListItem>
            </List>
        )
    } else {
        //
        // Registry status is most likely "Decommissioned" (other unlikely possibilites are "New" or "Ready")
        //
        return (
            <List>
                <ListItem sx={{p: 0, display: 'list-item'}}>
                    <ListItemText primary="Desktop QA"    secondary="Keep this task in the Desktop QA list, but save comments, etc." />
                </ListItem>
                <ListItem sx={{p: 0, display: 'list-item'}}>
                    <ListItemText primary="Field"         secondary="Request a field inspection to gather more information. Please use the comments field to say what information is needed and provide a separate list of required photos." />
                </ListItem>
                <ListItem sx={{p: 0, display: 'list-item'}}>
                    <ListItemText primary="Remedial"      secondary="Say remedial work is required by Northpower Contracting. Creates a Salesforce Case for the work. Your comments go on to the case." />
                </ListItem>
                <ListItem sx={{p: 0, display: 'list-item'}}>
                    <ListItemText primary="Eliminated"    secondary="Assess this ICP as safely decommissioned with no further work required." />
                </ListItem>
            </List>
        )
    }

}